import { html } from 'lit';
const Collections =
  ({ width = '1em', height = '1em', style = '' }: { width?: string, height?: string, style?: string } = {}) =>
    html`
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    width=${width}
    height=${height}
    fill="none"
    style=${'user-select:none;flex-shrink:0;' + style}
  >
    <path fill='currentColor' fill-rule="evenodd" d="M9 4.25a.75.75 0 0 0 0 1.5h6a.75.75 0 0 0 0-1.5zM6.25 8A.75.75 0 0 1 7 7.25h10a.75.75 0 0 1 0 1.5H7A.75.75 0 0 1 6.25 8m-2 5A2.75 2.75 0 0 1 7 10.25h10A2.75 2.75 0 0 1 19.75 13v5A2.75 2.75 0 0 1 17 20.75H7A2.75 2.75 0 0 1 4.25 18zM7 11.75c-.69 0-1.25.56-1.25 1.25v5c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25v-5c0-.69-.56-1.25-1.25-1.25z" clip-rule="evenodd"/>
  </svg>
`;
export default Collections;
